import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function SpecialistDoctorNavDetails(props) {
    const {doctor} = props;
    const {locale} = useRouter();

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {label: getLocaleContent(locale, 'page.specialist-doctor.breadcrumb-doctor'), href: '/chuyen-gia-bac-si', color: '#006940'},
                    {label: doctor?.full_name || getLocaleContent(locale, 'page.specialist-doctor.doctor-detail'), href: '#', color: '#2d2d2d'},
                ]}
            />
        </div>
    );
}

export default SpecialistDoctorNavDetails;
